import React from 'react';
import {
  Button,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalFooter,
  TableContainer,
  Table,
  Thead,
  Th,
  Tr,
  Tbody,
  Td,
  Flex,
} from '@chakra-ui/react';
import { useGetRepairItensFromIdQuery } from '@spartalabs/pdc-core';
import { Loading } from 'components/Loading';

interface FgtPwModalProps {
  isOpen: boolean;
  onClose: () => void;
  id: string;
}

export const ItensModal = ({ isOpen, onClose, id }: FgtPwModalProps) => {
  const {
    data: itens,
    isLoading,
    isFetching,
  } = useGetRepairItensFromIdQuery({ id });

  return (
    <Modal isCentered isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        minW={{ base: '80%', md: '800px' }}
        py="24px"
        px="18px"
        bg="white"
      >
        <ModalHeader p="0px" fontSize="xl" fontWeight={800} color="black">
          Peças/Serviços
        </ModalHeader>
        <ModalCloseButton bg="grey.200" borderRadius="36px" color="black" />
        {!itens || isLoading || isFetching ? (
          <Flex w="100%" h="100px" justify="center" align="center">
            <Loading />
          </Flex>
        ) : (
          <TableContainer pt="12px">
            <Table variant="striped" size="sm">
              <Thead bg="grey.200">
                <Tr>
                  <Th color="text.100">Tipo</Th>
                  <Th color="text.100">Descrição</Th>
                  <Th color="text.100" isNumeric>
                    Quantidade
                  </Th>
                  <Th color="text.100">Finalidade</Th>
                </Tr>
              </Thead>
              <Tbody>
                {itens.map((item, index) => (
                  <Tr key={index}>
                    <Td
                      fontWeight={400}
                      fontSize="12px"
                      color="text.100"
                      borderColor="grey.200"
                    >
                      {item.type}
                    </Td>
                    <Td
                      fontWeight={400}
                      fontSize="12px"
                      color="text.100"
                      borderColor="grey.200"
                    >
                      {item.description}
                    </Td>
                    <Td
                      textAlign="center"
                      fontWeight={400}
                      fontSize="12px"
                      color="text.100"
                      borderColor="grey.200"
                    >
                      {item.quantity}
                    </Td>
                    <Td
                      fontWeight={400}
                      fontSize="12px"
                      color="text.100"
                      borderColor="grey.200"
                    >
                      {item.justification}
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        )}

        <ModalFooter pb="0px">
          <Button variant="outline" onClick={onClose}>
            Voltar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
